export default "__VITE_ASSET__CegnHie3__"